import styled, { css } from 'styled-components';
import { Icon } from 'antd';

// Import styles
import { media } from 'components/styles';

// Import assets
import check from 'assets/icons/checkIcon.svg';

export const PacketWrapper = styled.section`
	width: 100%;
	display: grid;
	grid-template-columns: 1fr;
	row-gap: 10rem;
	margin: 10rem 0;

	${media.min.min(css`
		max-width: 85vw;
		margin: 0 auto;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		row-gap: 8rem;
		padding: 0rem 4rem;
		margin-bottom: 8rem;
	`)}

	${media.min.medium(css`
		max-width: unset;
		margin: 0;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		row-gap: 12rem;
		padding: 0rem 4rem;
		margin-bottom: 12rem;
		margin-top: 0;
	`)}

	${media.min.medium(css`
		padding: 0rem 7rem;
	`)}

	${media.min.max(css`
		padding: 0;
	`)}
`;

export const StyledQuestionIcon = styled(Icon)`
	display: inline;
	font-size: 1.25rem;
	font-weight: 400;
	color: ${({ theme }) => theme.iconGray};
	margin-left: ${({ space }) => `${space}px`};
	stroke-width: 0.35px;
	&:hover {
		opacity: 0.6;
		cursor: pointer;
	}
	${media.min.large(css`
		font-size: 1.6rem;
		margin-left: ${({ space }) => `${space}px`};
	`)}
`;

export const PacketMainContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
	width: 100%;
	max-width: 40rem;
	margin: 0 auto;
	margin-top: 2rem;
	margin-bottom: auto;
	color: ${({ theme }) => theme.white};
	flex-grow: 1;

	${media.min.xmin(css`
		width: 45rem;
	`)}
	${media.min.min(css`
		width: 30rem;
	`)}
	${media.min.large(css`
		width: 35rem;
	`)}
	padding: ${({ padding }) => padding};
	ul {
		list-style: none;
		margin-left: 0;
		padding-left: 0;
	}
	li {
		position: relative;
		box-sizing: border-box;
		color: ${({ theme }) => theme.white};
		font-weight: ${({ theme }) => theme.font.medium};
		font-size: 1.4rem;
		line-height: 1.9rem;
		margin-bottom: 2rem;
		letter-spacing: -10%;
		padding-left: 2.5rem;
		list-style-type: none;

		${media.min.large(css`
			padding-left: 3.5rem;
		`)};
	}
	li:before {
		content: '';
		height: 1.6rem;
		width: 1.6rem;
		position: absolute;
		left: 0;
		top: 0;
		background-position: center;
		background-repeat: no-repeat;
		background-size: 100%;
		background: url(${check});
		background-size: cover;
		background-position: center;

		${media.min.large(css`
			height: 2.1rem;
			width: 2.1rem;
		`)};
	}
`;

export const PacketsContentLink = styled.a`
	margin-left: 0.5rem;
	color: ${({ theme }) => theme.blueAzure};
`;
